
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/placeholder",
      function () {
        return require("private-next-pages/placeholder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/placeholder"])
      });
    }
  